import { fork, call, put, select, all, takeLatest, race, take, delay } from 'redux-saga/effects'
import moment from 'moment-timezone'
import api from 'lib/api/client'
import {
  startInit,
  finishInit,
  receiveLocations,
  receiveProjects,
  receiveReports
} from 'reports/production/actions'
import heartbeat from 'lib/saga/heartbeat'
import {
  selectToken,
  selectTimezone
} from 'reports/production/selectors'
import { SET_NAVIGATION, setNavigationDate, configureNavigation } from 'containers/Navigation/actions'
import { selectNavigationRange } from 'containers/Navigation/selectors'
import { TYPE_WEEK_DAY_SHIFT } from 'containers/Navigation/const'

const AUTORELOAD_INTERVAL = 60 * 1000

function * init () {
  const token = yield select(selectToken)
  const timezone = yield select(selectTimezone)

  yield put(startInit())

  yield put(configureNavigation(TYPE_WEEK_DAY_SHIFT))
  yield put(setNavigationDate(moment.tz({ hour: 0 }, timezone)))

  const [locations, projects] = yield all([
    call(api.get, '/locations', { token }),
    call(api.get, '/projects', { token })
  ])

  yield all([
    put(receiveLocations(locations)),
    put(receiveProjects(projects))
  ])

  yield put(finishInit())
}

function * reports () {
  const token = yield select(selectToken)
  const timezone = yield select(selectTimezone)
  const params = yield select(selectNavigationRange, timezone)

  const reports = yield call(api.get, '/reports/production', { params, token })

  yield put(receiveReports(reports))
}

function * reload () {
  let result

  while (true) {
    result = yield race({
      action: take(SET_NAVIGATION),
      timeout: delay(AUTORELOAD_INTERVAL)
    })

    if (result.timeout) {
      yield call(reports)
    }
  }
}

export default function * root () {
  if (process.env.NODE_ENV === 'development') {
    yield fork(heartbeat, 'Reports:Production')
  }

  yield call(init)
  yield call(reports)
  yield takeLatest(SET_NAVIGATION, reports)

  yield fork(reload)
}
